import { styled } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  'aria-label'?: string;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/** Divided list of `SuggestionItem`s, typically placed in a `CardResource` with `disableCardContent`. */
export function SuggestionList(props: Props) {
  return (
    <List aria-label={props['aria-label']} data-testid={props['data-testid'] ?? 'suggestion-list'}>
      {props.children}
    </List>
  );
}

export type { Props as SuggestionListProps };
